export const playerAppMeta = {
  name: 'Retro Arcade Player',
  milestone: 'M6',
  purpose: 'Published gameplay behind a versioned host/embed integration boundary',
} as const;
